import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { label: '恋爱漫画', path: '/category/love' },
    { label: '奇幻漫画', path: '/category/fantasy' },
    { label: '动作漫画', path: '/category/action' },
    { label: '悬疑漫画', path: '/category/thriller' },
    { label: '喜剧漫画', path: '/category/comedy' },
    { label: '剧情漫画', path: '/category/drama' },
  ],
  help: [
    { label: '阅读指南', path: '/about' },
    { label: '常见问题', path: '/about#faq' },
    { label: '联系我们', path: '/about#contact' },
    { label: '用户协议', path: '/about' },
  ],
  about: [
    { label: '品牌介绍', path: '/about#intro' },
    { label: '平台信誉', path: '/about#reputation' },
    { label: '加入我们', path: '/about#contact' },
    { label: '商务合作', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white mt-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="py-14 md:py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-14">
            <div className="lg:col-span-2">
              <Link to="/" className="inline-flex items-center gap-2.5 mb-5">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-book-open-line text-lg text-white"></i>
                </div>
                <span className="font-heading text-xl font-bold tracking-tight text-white">韩漫网</span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed mb-5 max-w-sm">
                韩漫网是领先的免费韩漫在线阅读平台，致力于为广大漫画爱好者提供高清下拉式全集韩漫资源。
                画质清晰、阅读流畅，打造影院级韩漫阅读体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-links-line text-white"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-white"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-movie-line text-white"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-chat-smile-2-line text-white"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-white font-semibold mb-5 text-sm">热门分类</h4>
              <ul className="space-y-3">
                {footerLinks.categories.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-white font-semibold mb-5 text-sm">帮助中心</h4>
              <ul className="space-y-3">
                {footerLinks.help.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-white font-semibold mb-5 text-sm">关于我们</h4>
              <ul className="space-y-3">
                {footerLinks.about.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} 韩漫网 HanManWang. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-400 text-xs hover:text-white transition-colors">隐私政策</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-white transition-colors">服务条款</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-white transition-colors">Cookie 设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}